import React from 'react';
import {AddCustomerContextProvider, useAddCustomerContext} from './AddCustomerContext';
import {AddEditCustomerForm} from './AddEditCustomerForm';
import ModalCommon from '../../../../common/components/ModalCommon';
import styles from './AddCustomerButton.module.scss';

const Modal = () => {
  const {isValid, submitForm} = useAddCustomerContext();

  return (
    <ModalCommon
      header={`יצירת לקוח חדש`}
      openButtonLabel={'הוספת לקוח חדש'}
      closeButtonLabel={'סגירה'}
      handleAction={submitForm}
      disableActionButton={!isValid}
      customModalTrigger={(
        <button
          type="button"
          className={styles.buttonOpen}
        >
          הוספת לקוח חדש
        </button>
      )}
      classNameTriggerContainer={styles.triggerContainer}
    >
      <AddEditCustomerForm/>
    </ModalCommon>
  );
};

export const AddCustomerButton = ({shumaID, onSuccess, onFail}) => {
  return (
    <>
      <AddCustomerContextProvider
        shumaID={shumaID}
        onFail={onFail}
        onSuccess={onSuccess}
      >
        <Modal/>
      </AddCustomerContextProvider>
    </>
  );
};